import { render, staticRenderFns } from "./BannerActivateWidget.vue?vue&type=template&id=85abdf44&scoped=true&"
import script from "./BannerActivateWidget.vue?vue&type=script&lang=ts&"
export * from "./BannerActivateWidget.vue?vue&type=script&lang=ts&"
import style0 from "./BannerActivateWidget.vue?vue&type=style&index=0&id=85abdf44&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85abdf44",
  null
  
)

export default component.exports